<div class="page-title-area">
    <div class="container-fluid">
        <div class="page-title-content">
            <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">Book a Demo</h2>
            <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Book a Demo</li>
            </ul>
        </div>
    </div>

</div>


<section class="calendar-section">
    <h2 class="calendar-section-title">
        Schedule Your Demo Now
    </h2>
    <!-- <div class="container calendly-inline-widget calendar"
    data-auto-load="false" data-url="https://calendly.com/vocbot-ai/30min"></div> -->
    <div id="calendly-embed" style="min-width:320px;height:700px;"></div>
    
  </section>
    